import { fetchLists } from 'common/actions/integrations/ActiveCampaign/actions/activeCampaignModalActions'
import {
  connectIntegrationByToken,
  disconnectIntegration,
} from 'common/actions/integrations/common/actions/integrationActions'
import * as atypes from 'common/actions/integrations/common/constants/IntegrationsReduxActionTypes'

const initialState = {
  identityField: {
    value: null,
    option: null,
  },
  isDisconnecting: false,
  isFetching: false,
  lists: [],
  selectedList: null,
  hasEmptyField: false,
}

export default function integrationsReducer(state = initialState, action) {
  const { data } = action

  switch (action.type) {
    case atypes.INTEGRATION_RESET: {
      return {
        ...state,
        ...initialState,
      }
    }

    case atypes.ACTIVE_CAMPAIGN_SET_IDENTITY_FIELD: {
      return { ...state, identityField: data }
    }

    case connectIntegrationByToken.pending.type: {
      return { ...state, isConnecting: true }
    }

    case connectIntegrationByToken.fulfilled.type:
    case connectIntegrationByToken.rejected.type: {
      return { ...state, isConnecting: false }
    }

    case disconnectIntegration.pending.type: {
      return { ...state, isDisconnecting: true }
    }
    case disconnectIntegration.fulfilled.type: {
      return { ...state, isDisconnecting: false }
    }

    case fetchLists.pending.type: {
      return {
        ...state,
        isFetching: true,
      }
    }
    case fetchLists.fulfilled.type: {
      const { lists } = action.payload
      return {
        ...state,
        lists,
        isFetching: false,
      }
    }
    case fetchLists.rejected.type: {
      return {
        ...state,
        isFetching: false,
      }
    }

    case atypes.ACTIVE_CAMPAIGN_SET_LIST: {
      return { ...state, selectedList: data }
    }

    case atypes.ACTIVE_CAMPAIGN_SET_FIELD_EMPTINESS: {
      return { ...state, hasEmptyField: data }
    }
  }

  return state
}
